// import React, { useEffect, useState } from "react";
// import { Col, Form, Row } from "react-bootstrap";
// import {
//   AddIconBlue,
//   DeleteIcon,
//   DragableIcon,
// } from "../../../../assets/images/svg/svg";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   updateBenefitType,
//   updateBenefitsName,
// } from "../../../../slices/product/productSlice";
// import {
//   addBenefitData,
//   deleteBenefitsList,
//   getAllBenefitsList,
// } from "../ProductService";

// ("./product.scss");

// const Benefits = () => {
//   const dispatch = useDispatch();

//   const benefitList = useSelector((state) => state.product.benefitListData);
//   const [localBenefitNames, setLocalBenefitNames] = useState({});

//   useEffect(() => {
//     let product_id = JSON.parse(localStorage.getItem("entity_id"));
//     getAllBenefitsList(product_id);
//   }, []);

//   useEffect(() => {
//     const initialNames = {};
//     benefitList.forEach((benefit) => {
//       initialNames[benefit.entityid] = benefit.name;
//     });
//     setLocalBenefitNames(initialNames);
//   }, [benefitList]);

//   // const handleDeleteType = (benefitId, type) => {
//   //   dispatch(deleteType({ id: benefitId, typeId: type }));
//   // };

//   const handleDeleteBenefits = (entityid) => {
//     let product_id = JSON.parse(localStorage.getItem("entity_id"));

//     deleteBenefitsList(entityid, product_id);
//   };

//   const handleAddBenefits = (benefit) => {
//     let product_id = JSON.parse(localStorage.getItem("entity_id"));
//     let organizationid = JSON.parse(localStorage.getItem("organizationId"));
//     if (benefit.name === "" || benefit.type === "") {
//       window.alert("Add Benefit");
//     } else {
//       addBenefitData(product_id, organizationid, benefit);
//     }
//   };

//   const typeOptions = [
//     {
//       label: "Boolean",
//       value: "BOOLEAN",
//     },
//     {
//       label: "Number",
//       value: "NUMBER",
//     },
//     {
//       label: "Percentage",
//       value: "PERCENTAGE",
//     },
//     {
//       label: "Date",
//       value: "DATE",
//     },
//   ];

//   const handleBenefitNameChange = (e, entityid) => {
//     dispatch(updateBenefitsName({ entityid: entityid, name: e.target.value }));
//   };

//   const handleSelectChange = (e, entityid) => {
//     dispatch(updateBenefitType({ entityid: entityid, value: e.target.value }));
//   };

//   return (
//     <div className="benefits-header">
//       <Row className="header">
//         <Col xs="1"></Col>
//         <Col xs="6">Benefit</Col>
//         <Col xs="5">Type</Col>
//         <Col xs="1"></Col>
//       </Row>
//       {benefitList.map((benefit, index) => (
//         <Row key={index} className="benefit-input">
//           <Col xs="1">
//             <DragableIcon />
//           </Col>
//           <Col xs="6">
//             <div>
//               <Form.Control
//                 type="text"
//                 value={benefit?.name}
//                 onChange={(e) => handleBenefitNameChange(e, benefit?.entityid)}
//               />
//             </div>
//           </Col>
//           <Col xs="5">
//             <div>
//               <Form.Select
//                 value={benefit?.type || ""}
//                 onChange={(e) => handleSelectChange(e, benefit?.entityid)}
//               >
//                 <option value="" disabled>
//                   Select type
//                 </option>
//                 {typeOptions.map((typeOption, ind) => (
//                   <option key={ind} value={typeOption.value}>
//                     {typeOption.label}
//                   </option>
//                 ))}
//               </Form.Select>
//             </div>
//           </Col>
//           <Col xs="1">
//             <div className="benefits-action-icon">
//               {index === benefitList.length - 1 || benefitList.length === 1 ? (
//                 <div onClick={() => handleAddBenefits(benefit)}>
//                   <AddIconBlue />
//                 </div>
//               ) : null}
//               {benefit.name === "" ? (
//                 <></>
//               ) : (
//                 <>
//                   <div onClick={() => handleDeleteBenefits(benefit.entityid)}>
//                     <DeleteIcon />
//                   </div>
//                 </>
//               )}
//             </div>
//           </Col>
//         </Row>
//       ))}
//     </div>
//   );
// };

// export default Benefits;

//? i have list if benefits i my redux
//? just fetch it here and show the list

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  AddIconBlue,
  DeleteIcon,
  DragableIcon,
} from "../../../../assets/images/svg/svg";
import { useDispatch, useSelector } from "react-redux";
import {
  updateBenefitType,
  updateBenefitsName,
} from "../../../../slices/product/productSlice";
import {
  addBenefitData,
  deleteBenefitsList,
  getAllBenefitsList,
  getBenefitList,
} from "../ProductService";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import "../product.scss";

const Benefits = () => {
  const dispatch = useDispatch();

  const benefitList = useSelector((state) => state.product.benefitListData);
  const [localBenefitList, setLocalBenefitList] = useState([]);
  const [isModified, setIsModified] = useState({});
  const detailsData = useSelector(
    (state) => state.product.selectedProduct.detailsData
  );

  const benefitArray = useSelector((state) => state.product.benefitListData);

  useEffect(() => {
    const fetchBenefits = async () => {
      try {
        let product_id = JSON.parse(localStorage.getItem("entity_id"));
        const fetchBenefitList = await getAllBenefitsList(detailsData.entityid);
        setLocalBenefitList(fetchBenefitList || []);
      } catch (error) {
        console.log("error", error);
        setLocalBenefitList([]);
      }
    };
    fetchBenefits();
    // getAllBenefitsList(product_id);
  }, [detailsData.entityid]);

  const handleDeleteBenefits = async (entityid, index) => {
    if (localBenefitList.length === 1) {
      setLocalBenefitList((prevList) =>
        prevList.map((benefit, idx) =>
          idx === 0 ? { ...benefit, name: "", type: "" } : benefit
        )
      );
    } else {
      setLocalBenefitList((prevList) =>
        prevList.filter((_, idx) => idx !== index)
      );
    }
  };

  const handleAddEmptyBenefit = () => {
    const newBenefit = { name: "", type: "" };
    setLocalBenefitList((prevList) => [...prevList, newBenefit]);
    setIsModified((prev) => ({ ...prev, [newBenefit.entityid]: true }));
  };

  // const handleAddBenefits = (benefit) => {
  //   let product_id = JSON.parse(localStorage.getItem("entity_id"));
  //   let organizationid = JSON.parse(localStorage.getItem("organizationId"));
  //   if (benefit.name === "" || benefit.type === "") {
  //     window.alert("Add Benefit");
  //   }
  // };

  const handleSaveBenefits = async (benefit) => {
    const validBenefits = localBenefitList.filter(
      (benefit) => benefit.name !== "" && benefit.type !== ""
    );

    if (validBenefits.length === 0) {
      window.alert("Add Benefit");
      return;
    }

    const benefitDataArray = validBenefits.map((benefit) => ({
      name: benefit.name,
      type: benefit.type,
    }));

    try {
      await getBenefitList(detailsData.entityid, benefitDataArray);

      const updatedBenefitList = await getAllBenefitsList(detailsData.entityid);
      setLocalBenefitList(updatedBenefitList || []);
      setIsModified({});
    } catch (error) {
      console.log("Error", error);
    }

    // if (benefit.name === "" || benefit.type === "") {
    //   window.alert("Add Benefit");
    // } else {
    //   addBenefitData(product_id, organizationid, benefit);`
    // }
  };
  const isFirstRowEmpty =
    localBenefitList[0]?.name === "" && localBenefitList[0]?.type === "";

  const typeOptions = [
    {
      label: "Boolean",
      value: "BOOLEAN",
    },
    {
      label: "Number",
      value: "NUMBER",
    },
    {
      label: "Percentage",
      value: "PERCENTAGE",
    },
    {
      label: "Date",
      value: "DATE",
    },
  ];

  const handleBenefitNameChange = (e, entityid) => {
    setLocalBenefitList((prevList) =>
      prevList.map((benefit) =>
        benefit.entityid === entityid
          ? { ...benefit, name: e.target.value }
          : benefit
      )
    );
    setIsModified((prev) => ({ ...prev, [entityid]: true }));
    // dispatch(updateBenefitsName({ entityid: entityid, name: e.target.value }));
  };

  const handleSelectChange = (e, entityid) => {
    setLocalBenefitList((prevList) =>
      prevList.map((benefit) =>
        benefit.entityid === entityid
          ? { ...benefit, type: e.target.value }
          : benefit
      )
    );
    setIsModified((prev) => ({ ...prev, [entityid]: true }));
    // dispatch(updateBenefitType({ entityid: entityid, value: e.target.value }));z
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(localBenefitList);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setLocalBenefitList(items);
  };

  return (
    <div>
      <div>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="benefits">
            {(provided) => (
              <div
                className="benefits-header"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <Row className="header">
                  <Col xs="1"></Col>
                  <Col xs="6">Benefit</Col>
                  <Col xs="5">Type</Col>
                  <Col xs="1"></Col>
                </Row>
                <div className="scrollable-container">
                  {localBenefitList.map((benefit, index) => (
                    <Draggable
                      key={benefit?.entityid ?? `benefit-${index}`}
                      draggableId={
                        benefit?.entityid?.toString() ?? `benefit-${index}`
                      }
                      index={index}
                    >
                      {(provided) => (
                        <Row
                          className="benefit-input"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Col xs="1">
                            <DragableIcon />
                          </Col>
                          <Col xs="6">
                            <div>
                              <Form.Control
                                type="text"
                                value={benefit?.name || ""}
                                onChange={(e) =>
                                  handleBenefitNameChange(e, benefit?.entityid)
                                }
                              />
                            </div>
                          </Col>
                          <Col xs="5">
                            <div>
                              <Form.Select
                                value={benefit?.type || ""}
                                onChange={(e) =>
                                  handleSelectChange(e, benefit?.entityid)
                                }
                              >
                                <option value="" disabled>
                                  Select type
                                </option>
                                {typeOptions.map((typeOption, ind) => (
                                  <option key={ind} value={typeOption.value}>
                                    {typeOption.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          </Col>
                          <Col xs="1">
                            <div className="benefits-action-icon">
                              {index === localBenefitList.length - 1 && (
                                <div onClick={handleAddEmptyBenefit}>
                                  <AddIconBlue />
                                </div>
                              )}

                              <div
                                onClick={() => {
                                  if (localBenefitList.length > 1) {
                                    handleDeleteBenefits(
                                      benefit.entityid,
                                      index
                                    );
                                  }
                                }}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <div className="save-btn">
        <Button
          onClick={handleSaveBenefits}
          disabled={!localBenefitList[0]?.name || !localBenefitList[0]?.type}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default Benefits;
